import * as yup from "yup";

export const schema = (t: (val: string) => string) => {
    const categoryValidation = yup.object().shape({
        name: yup.string().required(t("cmn:val.required")),
    });

    return categoryValidation;
};
